/* AMP3 Reviews on the product page (snippets/amp3-reviews.liquid). Loads more reviews, sorts and filters
   them, opens customer photos and videos, and records "Helpful" votes, all through the app proxy
   (/apps/reviews). Cards are built with textContent only (never innerHTML with review data), in the same
   markup as snippets/amp3-review-card.liquid; keep the two in step. */
(function () {
  "use strict";

  var STAR = "M12 2.6l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.4l-5.9 3.3 1.3-6.6L2.5 9.5l6.6-.8z";
  var SVG = "http://www.w3.org/2000/svg";

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function stars(rating) {
    var wrap = el("span", "a3-rv-stars");
    wrap.setAttribute("aria-hidden", "true");
    wrap.style.setProperty("--fill", Math.round(rating * 200) / 10 + "%");
    ["a3-rv-stars__base", "a3-rv-stars__fill"].forEach(function (cls) {
      var layer = el("span", cls);
      for (var i = 0; i < 5; i++) {
        var svg = document.createElementNS(SVG, "svg");
        svg.setAttribute("viewBox", "0 0 24 24");
        svg.setAttribute("focusable", "false");
        var p = document.createElementNS(SVG, "path");
        p.setAttribute("d", STAR);
        svg.appendChild(p);
        layer.appendChild(svg);
      }
      wrap.appendChild(layer);
    });
    return wrap;
  }

  function withWidth(url, w) {
    return url + (url.indexOf("?") >= 0 ? "&" : "?") + "width=" + w;
  }

  function longDate(ymd) {
    var d = new Date(ymd + "T12:00:00Z");
    return isNaN(d) ? ymd : d.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" });
  }

  function paragraphs(text) {
    var p = el("p", "a3-rv__body");
    String(text).split("\n").forEach(function (line, i) {
      if (i) p.appendChild(document.createElement("br"));
      p.appendChild(document.createTextNode(line));
    });
    return p;
  }

  function card(c, incentive) {
    var a = el("article", "a3-rv__card");
    a.setAttribute("data-review", c.id);
    var head = el("div", "a3-rv__head");
    var rating = el("span", "a3-rv__rating");
    rating.setAttribute("role", "img");
    rating.setAttribute("aria-label", c.rating + " out of 5 stars");
    rating.appendChild(stars(c.rating));
    head.appendChild(rating);
    if (c.title) head.appendChild(el("h3", "a3-rv__title", c.title));
    a.appendChild(head);
    a.appendChild(paragraphs(c.body));
    if (c.answers && c.answers.length) {
      var dl = el("dl", "a3-rv__answers");
      c.answers.forEach(function (x) {
        var row = el("div");
        row.appendChild(el("dt", null, x.label));
        row.appendChild(el("dd", null, x.text));
        dl.appendChild(row);
      });
      a.appendChild(dl);
    }
    if (c.media && c.media.length) {
      var ul = el("ul", "a3-rv__media");
      c.media.forEach(function (m) {
        var li = el("li");
        var b = el("button", "a3-rv__thumb" + (m.type === "video" ? " is-video" : ""));
        b.type = "button";
        b.setAttribute("data-a3-rv-open", m.url);
        b.setAttribute("data-type", m.type);
        b.setAttribute("aria-label", (m.type === "video" ? "Play " : "View ") + c.name + (m.type === "video" ? "'s video" : "'s photo"));
        var img = el("img");
        img.src = withWidth(m.preview || m.url, 240);
        img.alt = "";
        img.loading = "lazy";
        img.width = 120;
        img.height = 120;
        b.appendChild(img);
        li.appendChild(b);
        ul.appendChild(li);
      });
      a.appendChild(ul);
    }
    var meta = el("p", "a3-rv__meta");
    meta.appendChild(el("strong", null, c.name));
    if (c.date) {
      meta.appendChild(el("span", null, " · "));
      var t = el("time", null, longDate(c.date));
      t.setAttribute("datetime", c.date);
      meta.appendChild(t);
    }
    if (c.variant) meta.appendChild(el("span", null, " · " + c.variant));
    a.appendChild(meta);
    var labels = el("ul", "a3-rv__labels");
    if (c.verified) labels.appendChild(el("li", null, "Verified buyer"));
    if (c.openBox) labels.appendChild(el("li", null, "Bought open-box"));
    if (c.source === "previous_site") labels.appendChild(el("li", null, "From our previous website"));
    if (c.incentivised) {
      var gift = el("li", "is-gift");
      var link = el("a", null, "Incentivised review");
      link.href = "#a3-rv-about";
      link.title = "This customer was offered a " + incentive + " for writing a review";
      gift.appendChild(link);
      labels.appendChild(gift);
    }
    a.appendChild(labels);
    // Staff comments (AMP3 Reviews R20): the thread in c.replies, oldest first; older cards carry only c.reply.
    var replies = c.replies && c.replies.length ? c.replies : c.reply ? [{ body: c.reply.body, by: null, date: null }] : [];
    replies.forEach(function (x) {
      var r = el("div", "a3-rv__reply");
      r.appendChild(el("strong", null, "Reply from AMP3"));
      var rp = paragraphs(x.body);
      rp.className = "";
      r.appendChild(rp);
      if (x.by) {
        var by = el("p", "a3-rv__reply-by", x.by + ", the amp3 team");
        if (x.date) {
          by.appendChild(document.createTextNode(" · "));
          var bt = el("time", null, longDate(x.date));
          bt.setAttribute("datetime", x.date);
          by.appendChild(bt);
        }
        r.appendChild(by);
      }
      a.appendChild(r);
    });
    var h = el("p", "a3-rv__helpful", "Helpful? ");
    var hb = el("button", null, c.helpful > 0 ? "Yes (" + c.helpful + ")" : "Yes");
    hb.type = "button";
    hb.setAttribute("data-a3-rv-helpful", "");
    h.appendChild(hb);
    a.appendChild(h);
    return a;
  }

  function voted() {
    try { return JSON.parse(localStorage.getItem("a3-rv-voted") || "[]"); } catch (e) { return []; }
  }
  function remember(id) {
    try { var v = voted(); v.push(id); localStorage.setItem("a3-rv-voted", JSON.stringify(v.slice(-200))); } catch (e) { /* private mode */ }
  }

  function init(root) {
    var endpoint = root.getAttribute("data-endpoint");
    var product = root.getAttribute("data-product");
    var incentive = root.getAttribute("data-incentive");
    var total = Number(root.getAttribute("data-total"));

    // "Write a review": the customer gives the email address on their order; the app sends the review link to it
    // if a delivered website order for this product exists. The answer shown is the same whatever was found.
    var writeBtn = root.querySelector("[data-a3-rv-write]");
    var form = root.querySelector("[data-a3-rv-request]");
    if (writeBtn && form) {
      var reqStatus = form.querySelector("[data-a3-rv-request-status]");
      var emailInput = form.querySelector("input[type=email]");
      var sendBtn = form.querySelector("[type=submit]");
      writeBtn.addEventListener("click", function () {
        var opening = form.hidden;
        form.hidden = !opening;
        writeBtn.setAttribute("aria-expanded", String(opening));
        if (opening && emailInput) emailInput.focus();
      });
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var email = emailInput ? emailInput.value.trim() : "";
        if (email.indexOf("@") < 1 || email.indexOf(".", email.indexOf("@")) < 0) {
          reqStatus.textContent = "Enter the email address you used on your order.";
          if (emailInput) emailInput.focus();
          return;
        }
        if (sendBtn) sendBtn.disabled = true;
        reqStatus.textContent = "Sending…";
        fetch(endpoint + "/api/request-link", { method: "POST", credentials: "same-origin", headers: { "content-type": "application/json" }, body: JSON.stringify({ email: email, product: product }) })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            reqStatus.textContent = d.message || "Thanks. If we find a delivered website order for this product under that email address, your review link is on its way.";
            if (d.ok) form.reset();
          })
          .catch(function () { reqStatus.textContent = "Sorry, that didn't work. Please try again in a moment."; })
          .then(function () { if (sendBtn) sendBtn.disabled = false; });
      });
    }

    var list = root.querySelector("[data-a3-rv-list]");
    if (!list) return;
    var more = root.querySelector("[data-a3-rv-more]");
    var status = root.querySelector("[data-a3-rv-status]");
    var sortSel = root.querySelector("[data-a3-rv-sort]");
    var mediaBox = root.querySelector("[data-a3-rv-media]");
    var clear = root.querySelector("[data-a3-rv-clear]");
    var starButtons = root.querySelectorAll("[data-a3-rv-stars]");
    // The page Liquid rendered is page 1 of the default view (newest, no filters).
    var state = { page: 1, pages: Math.max(1, Math.ceil(total / 10)), sort: "newest", stars: null, media: false, loading: false };

    function markVoted() {
      var v = voted();
      Array.prototype.forEach.call(list.querySelectorAll("[data-review]"), function (a) {
        if (v.indexOf(a.getAttribute("data-review")) >= 0) {
          var b = a.querySelector("[data-a3-rv-helpful]");
          if (b) b.disabled = true;
        }
      });
    }

    function load(replace) {
      if (state.loading) return;
      state.loading = true;
      status.textContent = "Loading reviews…";
      var page = replace ? 1 : state.page + 1;
      var q = "product=" + encodeURIComponent(product) + "&page=" + page + "&sort=" + state.sort + (state.stars ? "&stars=" + state.stars : "") + (state.media ? "&media=1" : "");
      fetch(endpoint + "/reviews?" + q, { credentials: "same-origin", headers: { accept: "application/json" } })
        .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
        .then(function (d) {
          if (replace) list.textContent = "";
          d.reviews.forEach(function (c) { list.appendChild(card(c, incentive)); });
          state.page = d.page;
          state.pages = d.pages;
          status.textContent = replace ? (d.total === 1 ? "1 review" : d.total + " reviews") : "";
          if (more) more.hidden = d.page >= d.pages;
          markVoted();
        })
        .catch(function () { status.textContent = "Sorry, we couldn't load more reviews. Please try again."; })
        .then(function () { state.loading = false; });
    }

    function refilter() {
      if (clear) clear.hidden = !(state.stars || state.media);
      Array.prototype.forEach.call(starButtons, function (b) { b.setAttribute("aria-pressed", String(Number(b.getAttribute("data-a3-rv-stars")) === state.stars)); });
      load(true);
    }

    if (more) more.addEventListener("click", function () { load(false); });
    if (sortSel) sortSel.addEventListener("change", function () { state.sort = sortSel.value; refilter(); });
    if (mediaBox) mediaBox.addEventListener("change", function () { state.media = mediaBox.checked; refilter(); });
    Array.prototype.forEach.call(starButtons, function (b) {
      b.addEventListener("click", function () {
        var n = Number(b.getAttribute("data-a3-rv-stars"));
        state.stars = state.stars === n ? null : n;
        refilter();
        list.scrollIntoView({ block: "nearest" });
      });
    });
    if (clear) clear.addEventListener("click", function () { state.stars = null; state.media = false; if (mediaBox) mediaBox.checked = false; refilter(); });

    // Helpful votes and the photo/video viewer (event delegation covers cards added later).
    var viewer = root.querySelector("[data-a3-rv-viewer]");
    var viewerBody = root.querySelector("[data-a3-rv-viewer-body]");
    root.addEventListener("click", function (e) {
      var helpful = e.target.closest("[data-a3-rv-helpful]");
      if (helpful && !helpful.disabled) {
        var art = helpful.closest("[data-review]");
        var id = art && art.getAttribute("data-review");
        if (!id) return;
        helpful.disabled = true;
        fetch(endpoint + "/api/helpful", { method: "POST", credentials: "same-origin", headers: { "content-type": "application/json" }, body: JSON.stringify({ reviewId: id, vote: 1 }) })
          .then(function (r) { return r.json(); })
          .then(function (d) { if (d.ok) { helpful.textContent = "Yes (" + d.helpful + ")"; remember(id); } else helpful.disabled = false; })
          .catch(function () { helpful.disabled = false; });
        return;
      }
      var open = e.target.closest("[data-a3-rv-open]");
      if (open && viewer && viewerBody) {
        viewerBody.textContent = "";
        var isVideo = open.getAttribute("data-type") === "video";
        var media = el(isVideo ? "video" : "img");
        media.src = isVideo ? open.getAttribute("data-a3-rv-open") : withWidth(open.getAttribute("data-a3-rv-open"), 1600);
        if (isVideo) { media.controls = true; media.autoplay = true; media.playsInline = true; } else media.alt = "Customer photo";
        viewerBody.appendChild(media);
        if (viewer.showModal) viewer.showModal(); else viewer.setAttribute("open", "");
        return;
      }
      if (e.target.closest("[data-a3-rv-close]") || e.target === viewer) {
        viewerBody.textContent = "";
        if (viewer.close) viewer.close(); else viewer.removeAttribute("open");
      }
    });
    markVoted();
  }

  function start() { Array.prototype.forEach.call(document.querySelectorAll("[data-a3-rv]"), init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
